import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Current festival “workspace” for admin routes (nav, forms, entity CRUD).
 * Replaces legacy `festivalStore.festival` from Redux.
 */
export const useFestivalWorkspaceStore = create(
  persist(
    (set) => ({
      festival: {},
      setFestival: (festival) => set({ festival: festival ?? {} }),
      patchFestival: (partial) =>
        set((state) => ({
          festival: { ...state.festival, ...partial },
        })),
      clearFestivalWorkspace: () => set({ festival: {} }),
    }),
    {
      name: 'festy-festival-workspace',
      partialize: (state) => ({ festival: state.festival }),
    },
  ),
);
